import { FC } from "react";
import { cn } from "@/ui/lib";
import { BASE_INPUT_CLASSES, INPUT_ERROR_CLASSES } from "../forms.config";
import { TInputFieldProps } from "./Input.config";

export const InputField: FC<TInputFieldProps> = ({
  type,
  value,
  disabled,
  error,
  className,
  ...props
}) => (
  <input
    {...props}
    aria-invalid={!!error}
    type={type}
    value={value}
    disabled={disabled}
    className={cn(
      BASE_INPUT_CLASSES,
      "p-2 overflow-hidden overflow-ellipsis",
      error && INPUT_ERROR_CLASSES,
      className,
    )}
  />
);
